import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';
import {AppService} from '@app/app.service';
import {Select} from '@app/core/libraries/Dynamic-fields/components/select/classes/Select.class';
import {SelectService} from './select-service.service';
import {MatLegacySelect as MatSelect} from '@angular/material/legacy-select';
import {TuiDestroyService} from '@taiga-ui/cdk';

@Component({
    selector: 'df-app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.scss', '../../../../shared/components/button/styles/button.scss'],
    providers: [SelectService, TuiDestroyService]
})
export class SelectComponent extends Select implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    @ViewChild('matSelect', {static: false}) declare matSelect: MatSelect;

    constructor(
        @Inject(TuiDestroyService) protected _destroy$: TuiDestroyService,
        public appService: AppService,
        public service: SelectService) {
        super(_destroy$, service);
    }

    /** Вызывается один раз после установки свойств компонента */
    ngOnInit(): void {
        super.ngOnInit();
        setTimeout(() => {
            this.matSelect._overlayPanelClass += 'custom-select-panel';
        });
    }

    /**
     * Установка опций селекта
     * @param options опции селекта
     */
    setOptions(options) {
        this.field.options = options.slice();
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.group.get(this.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }
}
